import {createAsyncThunk} from '@reduxjs/toolkit'

import {sessions} from "../../api/sessions";

const fetchList = createAsyncThunk('sessions/fetchList', async (id) => {
  try {
    const sessionList = await sessions.methods.getList();
    console.log(sessionList)
    return sessionList;
  } catch (e) {
    console.error("[sessions/fetchList] Error: ", e);
    throw e;
  }
})


export const SessionsActions = {
  fetchList
}
